class NappiCartTimer extends HTMLElement {
  static KEY = "nappi:cart-timer-deadline";
  /*
   * Le morph d'Horizon réaligne les attributs sur le HTML de réponse, où le
   * bandeau n'est jamais masqué : il effaçait donc `hidden` au premier
   * re-rendu, et une minuterie expirée réapparaissait. On surveille l'attribut
   * pour le reposer. Pas de boucle : reposer `hidden` rappelle ce callback avec
   * une valeur non nulle, qui ne déclenche rien.
   */
  static observedAttributes = ["hidden"];
  attributeChangedCallback(nom, ancien, nouveau) {
    if (nom === "hidden" && nouveau === null && this.expire) this.hidden = true;
  }
  connectedCallback() {
    const seconds = parseInt(this.dataset.seconds, 10);
    if (!Number.isFinite(seconds) || seconds <= 0) {
      this.#retirer();
      return;
    }
    this.output = this.querySelector("[data-timer-value]");
    if (!this.output) return;
    const deadline = this.#deadline(seconds);
    if (deadline === null) {
      this.#retirer();
      return;
    }
    this.deadline = deadline;
    this.#tick();
    this.interval = setInterval(() => this.#tick(), 1e3);
  }
  disconnectedCallback() {
    clearInterval(this.interval);
  }
  /* Reprend l'échéance en cours si elle existe et n'est pas passée ; sinon en
     pose une nouvelle. Renvoie null si le stockage est inaccessible ET que la
     minuterie a déjà expiré dans cette page. */
  #deadline(seconds) {
    let stored = null;
    try {
      stored = sessionStorage.getItem(NappiCartTimer.KEY);
    } catch (e) {
    }
    const parsed = stored ? parseInt(stored, 10) : NaN;
    if (Number.isFinite(parsed)) {
      if (parsed > Date.now()) return parsed;
      if (!this.hasAttribute("data-loop")) return null;
    }
    const fresh = Date.now() + seconds * 1e3;
    try {
      sessionStorage.setItem(NappiCartTimer.KEY, String(fresh));
    } catch (e) {
    }
    return fresh;
  }
  #tick() {
    const left = Math.max(0, Math.round((this.deadline - Date.now()) / 1e3));
    const mm = String(Math.floor(left / 60)).padStart(2, "0");
    const ss = String(left % 60).padStart(2, "0");
    this.output.textContent = `${mm}:${ss}`;
    this.output.setAttribute("datetime", `PT${Math.floor(left / 60)}M${left % 60}S`);
    if (left === 0) {
      if (this.hasAttribute("data-loop")) {
        try {
          sessionStorage.removeItem(NappiCartTimer.KEY);
        } catch (e) {
        }
        this.deadline = this.#deadline(parseInt(this.dataset.seconds, 10));
        return;
      }
      clearInterval(this.interval);
      this.#retirer();
    }
  }
  /*
   * On MASQUE, on ne retire pas. Le serveur continue de rendre ce bandeau à
   * chaque re-rendu de section ; retirer le nœud désalignait la liste d'enfants
   * de `.cart-drawer__content` entre le DOM vivant et le HTML de réponse, et le
   * morph d'Horizon, qui apparie par position, finissait par dupliquer la barre
   * de livraison offerte. Symptôme observé le 20/09/2026 : deux barres après la
   * suppression d'une ligne, dès que la minuterie avait expiré dans la session.
   *
   * `display: none` est posé explicitement dans assets/nappi-cart.css : la
   * règle `.nappi-cart-timer { display: block }` l'emporterait sinon sur le
   * comportement natif de l'attribut `hidden`.
   */
  #retirer() {
    this.expire = true;
    this.hidden = true;
  }
}
(() => {
  let interne = false;
  try {
    interne = Boolean(document.referrer) && new URL(document.referrer).host === window.location.host;
  } catch (e) {
  }
  if (interne) return;
  try {
    sessionStorage.removeItem(NappiCartTimer.KEY);
  } catch (e) {
  }
})();
if (!customElements.get("nappi-cart-timer")) {
  customElements.define("nappi-cart-timer", NappiCartTimer);
}
